import * as React from 'react';
import { useSelector } from 'react-redux';

import { IAsyncData } from '../../models';
import { IContactDetails } from '../../modules/Contacts/models';
import { IApplicationState } from '../../store/models';
import { Async } from '../AsyncProvider';

import './index.scss';

export const SocialNetworks: React.FC = () => {
    const configurationBranch = useSelector<IApplicationState, IAsyncData<IContactDetails>>((state) => state.contact.configuration);

    return (
        <Async
            branch={configurationBranch}
            deps={[configurationBranch]}
            successRender={({ facebook, twitter, linkedin, instagram }) => {
                const socialNetworks = [
                    {
                        href: facebook,
                        icon: 'icon-fb',
                    },
                    {
                        href: twitter,
                        icon: 'icon-twitter',
                    },
                    {
                        href: linkedin,
                        icon: 'icon-linkedin',
                    },
                    {
                        href: instagram,
                        icon: 'icon-instagram',
                    }
                ];

                return (
                    <div className="social-networks">
                        <ul>
                            {
                                socialNetworks.map((socialNetwork) => socialNetwork.href && (
                                    <li key={socialNetwork.icon + socialNetwork.href}>
                                        <a
                                            rel="noopener noreferrer"
                                            href={socialNetwork.href}
                                            target="_blank"
                                        >
                                            <i className={socialNetwork.icon} />
                                        </a>
                                    </li>
                                )).filter(Boolean)
                            }
                        </ul>
                    </div>
                );
            }}
        />
    );
};
